import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbItem {
  name: string;
  slug: string;
  path: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
}
export function Breadcrumb({
  items
}: BreadcrumbProps) {
  return <nav aria-label="Breadcrumb" className="mb-6" data-id="element-57">
      <ol className="flex items-center flex-wrap gap-2 text-sm md:text-base" data-id="element-58">
        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <li key={item.path} className="flex items-center gap-2" data-id="element-59">
              {isLast ? <span className="font-bold text-gray-900" data-id="element-60">{item.name}</span> : <>
                  <Link to={item.path} className="text-gray-500 hover:text-kithward-700 transition-colors" data-id="element-61">
                    {item.name}
                  </Link>
                  <ChevronRight className="w-4 h-4 text-gray-400" data-id="element-62" />
                </>}
            </li>;
      })}
      </ol>
    </nav>;
}